<template>
    <div class="azimuth">
        <div class="azimuth__inner">
            <circle-slider
                :value="parsedValue"
                :side="290"
                :min="0"
                :max="360"
                :step-size="5"
                :circle-width="1"
                :progress-width="1"
                :knob-radius="15"
                circle-color="rgba(255,255,255, 0.5)"
                progress-color="none"
                @input="$emit('input', $event)"
            />
            <span class="coord n">N</span>
            <span class="coord s">S</span>
            <span class="coord e">E</span>
            <span class="coord w">W</span>
            <span class="point ne" />
            <span class="point se" />
            <span class="point nw" />
            <span class="point sw" />
            <span class="total">{{ parsedValue }}&deg; {{ direction }}</span>
        </div>

        <Tooltip class="azimuth__tooltip" text="0 degrees on the compass represents True North" />
    </div>
</template>

<script>
import CircleSlider from '@/components/circle-slider/CircleSlider';
import Tooltip from '@/components/Tooltip';

export default {
    components: {
        CircleSlider,
        Tooltip
    },

    props: {
        value: {
            type: [Number, String],
            default: 0
        }
    },

    computed: {
        direction() {
            let direction;
            if (this.parsedValue == 0) direction = 'N';
            if (this.parsedValue > 0) direction = 'NE';
            if (this.parsedValue == 90) direction = 'E';
            if (this.parsedValue > 90) direction = 'SE';
            if (this.parsedValue == 180) direction = 'S';
            if (this.parsedValue > 180) direction = 'SW';
            if (this.parsedValue == 270) direction = 'W';
            if (this.parsedValue > 270) direction = 'NW';
            return direction;
        },

        parsedValue() {
            return Number(this.value);
        }
    },

    watch: {
        value(newValue) {
            if (newValue === 360) this.$emit('input', 0);
        }
    }
};
</script>

<style lang="scss" scoped>
    .azimuth {
        display: flex;
        justify-content: center;
        position: relative;

        &::v-deep svg {
            display: block;
            transform: rotate(180deg);

            circle {
                // Outer circle
                &:first-child {
                    fill: rgba(255,255,255,0.1);
                    stroke-dasharray: 3;
                }

                // Current value dot
                &:last-child {
                    // stroke: #FFFFFF;
                    // stroke-width: 12px;
                }
            }
        }
    }

    .azimuth__inner {
        position: relative;

        .coord {
            display: block;
            position: absolute;
            width: 20px;
            height: 20px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 1;
            pointer-events: none;
        }

        .n {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);

            &::after {
                transform: rotate(-45deg) translate(100%, 100%);
            }
        }

        .s {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);

            &::after {
                transform: rotate(90deg);
            }
        }

        .e {
            top: 50%;
            right: 12%;
            transform: translateY(-50%);
        }

        .w {
            top: 50%;
            left: 12%;
            transform: translateY(-50%);
        }

        .point {
            position: absolute;
            display: block;
            width: 20px;
            height: 1px;
            background-color: rgba(255,255,255,0.5);
            content: "";
            pointer-events: none;
        }

        .nw {
            top: 23%;
            left: 20%;
            transform: rotate(45deg);
        }

        .se {
            bottom: 23%;
            right: 20%;
            transform: rotate(45deg);
        }

        .ne {
            top: 23%;
            right: 20%;
            transform: rotate(-45deg);
        }

        .sw {
            bottom: 23%;
            left: 20%;
            transform: rotate(-45deg);
        }

        .total {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1.5rem;
            color: #FFFFFF;
        }
    }

    .azimuth__tooltip {
        position: absolute;
        bottom: 0;
        left: 0;

        &::v-deep .tool-tip {
            right: auto;
            left: -20px;

            &::after {
                right: auto;
                left: 9%;
            }
        }
    }
</style>
